import { Box } from '@rebass/emotion';
import TableOfComponents from "../../../../docs/getting-started/table-of-components.mdx";
import * as React from 'react';
export default {
  Box,
  TableOfComponents,
  React
};